<template>
  <div id="">
    <img src="../assets/download2.svg" class="dbutton" />
  </div>
</template>
<script>
export default {
  name: "",
  data: () => ({

  })
}
</script>
<style>

</style>
